export default function DefaultUser({ seed, color, config, className }) {
  return (
    <svg
      style={config}
      className={className}
      version="1.1"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m0 0v512h15v-6.5938c0-82.655 59.02-163.37 239.2-163.37 180.18 0 242.93 85.074 243.11 169.96h14.697v-512h-512zm256.42 81.588a117.39 117.39 0 0 1 117.38 117.38 117.39 117.39 0 0 1-117.38 117.38 117.39 117.39 0 0 1-117.38-117.38 117.39 117.39 0 0 1 117.38-117.38z"
        fill={color}
      />
    </svg>
  )
}
